import groq from 'groq';

export const CONTACT_INFORMATION_QUERY = groq`
  *[_type == "contactInformation"][0] {
    _id,
    title,
    description,
    branches[] {
      name,
      phone,
      email,
      address
    }
  }
`;

export const localizedContactInformationQuery = (locale: string) => groq`
  *[_type == "contactInformation"][0] {
    _id,
    "title": title.${locale},
    "description": description.${locale},
    branches[] {
      "name": name.${locale},
      phone,
      email,
      "address": address.${locale}
    }
  }
`;
